import { Box, makeStyles, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  error: {
    padding: 12,
    borderRadius: 4,
    marginBottom: 16,
    backgroundColor: theme.palette.semantic["status/error-bg"],
    color: theme.palette.error.main,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  header: { display: "flex", alignItems: "flex-start", gap: 4 },
  icon: { display: "block", flexShrink: 0, marginTop: 2 },
  errorTitle: { fontSize: 14, lineHeight: 1.3, fontWeight: 500, textWrap: "balance" },
  errorDescription: { fontSize: 14, lineHeight: 1.5, color: theme.palette.text.primary },
  text: { fontSize: 14, lineHeight: 1.5, overflowWrap: "anywhere" },
  title: { fontSize: 14, lineHeight: 1.5, fontWeight: 700 },
  mark: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.semantic["status/success"],
    backgroundColor: theme.palette.semantic["status/success-bg"],
  },
  invalid: { color: theme.palette.error.main, backgroundColor: theme.palette.semantic["surface/base"] },
  note: { padding: 16, borderRadius: 4, backgroundColor: theme.palette.semantic["surface/base"] },
}));

export const AuthErrorSummary: React.FC<{ message: string; description?: string }> = ({ message, description }) => {
  const classes = useStyles();
  if (!message) return null;
  return (
    <Box className={classes.error} role="alert">
      <Box className={classes.header}>
        <img src="/icons/ds-v2-error-summary.svg" className={classes.icon} alt="" aria-hidden="true" />
        <Typography className={classes.errorTitle}>{message}</Typography>
      </Box>
      {description && <Typography className={classes.errorDescription}>{description}</Typography>}
    </Box>
  );
};

export const AuthStatusMark: React.FC<{ invalid?: boolean }> = ({ invalid }) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.mark} ${invalid ? classes.invalid : ""}`} aria-hidden="true">
      {invalid ? <ErrorOutlineIcon style={{ fontSize: 40 }} /> : <CheckIcon style={{ fontSize: 40 }} />}
    </Box>
  );
};

export const AuthNote: React.FC<{ title?: string }> = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Box className={classes.note}>
      {title && (
        <Typography className={classes.title} style={{ marginBottom: 8 }}>
          {title}
        </Typography>
      )}
      <Typography component="div" className={classes.text} color="textSecondary">
        {children}
      </Typography>
    </Box>
  );
};
